
import React from 'react';

export function useHotelFormState() {
  // Hotel specific states
  const [hotelClass, setHotelClass] = React.useState('');
  const [checkInTime, setCheckInTime] = React.useState('');
  const [checkOutTime, setCheckOutTime] = React.useState('');
  const [hasPool, setHasPool] = React.useState(false);
  const [hasSpa, setHasSpa] = React.useState(false);
  const [hasFitnessCenter, setHasFitnessCenter] = React.useState(false);
  const [hasRoomService, setHasRoomService] = React.useState(false);

  const resetHotelFormState = () => {
    setHotelClass('');
    setCheckInTime('');
    setCheckOutTime('');
    setHasPool(false);
    setHasSpa(false);
    setHasFitnessCenter(false);
    setHasRoomService(false);
  };

  return {
    hotelClass, setHotelClass,
    checkInTime, setCheckInTime,
    checkOutTime, setCheckOutTime,
    hasPool, setHasPool,
    hasSpa, setHasSpa,
    hasFitnessCenter, setHasFitnessCenter,
    hasRoomService, setHasRoomService,
    resetHotelFormState
  };
}
